<template>
  <el-container v-if="web_index" style="height:100%;">
    <webindex></webindex>
  </el-container>
  <el-container v-else style="height:100%;">
    <Transition>
      <div v-if="!fullmode" class="toppest">
        请旋转至竖屏模式并锁定屏幕旋转
      </div>
    </Transition>
    <Transition>
      <div class="swiper_marktag_btn" v-if="show_mark_btn && !isphone">
        <el-checkbox-button disabled>点击右方按钮进行标记
          <p
            style="font-size:12px;position:absolute;bottom:-40px;left:0px;opacity:0.7;color:rgb(255, 255, 255);background-color:#303030;padding:4px;border-radius:4px;">
            空格键 或 小键盘0键 可快速标记【{{ task_info.tags[0] }}】</p>
        </el-checkbox-button>
        <el-checkbox-button class="mycheck" disabled @change="swiper_markbtn_click($event, '推荐')"
          :value="checktag(preview_files[preview_index].title, '推荐')"><i class="el-icon-star-on"></i> 推荐 ({{
            calc_tagcount('推荐')
          }})</el-checkbox-button>
        <el-checkbox-button :class="task_info.status == 'yes' ? 'mycheck' : ''" :disabled="task_info.status == 'yes'"
          v-for="(item, index) in task_info.tags" :key="index" @change="swiper_markbtn_click($event, item)"
          :value="checktag(preview_files[preview_index].title, item)">{{ item }} ({{ calc_tagcount(item)
          }})
        </el-checkbox-button>
        <el-checkbox-button disabled>已选 {{ calc_tagcount('已标记') }}/{{ task_info.ruce_num }} 张</el-checkbox-button>
      </div>
    </Transition>
    <Transition>
      <div class="swiper_marktag_btn_phone" v-if="show_mark_btn && isphone">
        <div class="swiper_marktags_phone_toptip">

          <span style="line-height:40px;"><i class="el-icon-info" @click="show_control_desc"
              style="margin-right:4px;font-size: 15px;"></i>已选 {{
                calc_tagcount('已标记') }}/{{ task_info.ruce_num }} 张</span>
          <span style="line-height:40px;"> <el-button type="info" size="mini" @click="close_swipe()">返回缩略图</el-button>
          </span>
          <span v-if="calc_tagcount('已标记') > task_info.ruce_num && task_info.over_price_show == 'yes'"
            style="line-height:40px;">加片金额 ￥{{
              (calc_tagcount('已标记') - task_info.ruce_num) * task_info.over_price }}元</span>
        </div>
        <div class="swiper_marktags_phone">
          <el-checkbox-button class="mycheck marktag_phone" disabled @change="swiper_markbtn_click($event, '推荐')"
            :value="checktag(preview_files[preview_index].title, '推荐')">推荐 ({{ calc_tagcount('推荐')
            }})</el-checkbox-button>
          <el-checkbox-button :class="task_info.status == 'yes' ? 'marktag_phone mycheck2' : 'marktag_phone'"
            v-for="(item, index) in task_info.tags" :key="index" @change="swiper_markbtn_click($event, item)"
            :value="checktag(preview_files[preview_index].title, item)" :disabled="task_info.status == 'yes'">{{
              item }} ({{ calc_tagcount(item)
  }})</el-checkbox-button>
        </div>

        <div style="margin:20px 0 10px 0;opacity: 0.5;" align="center"><el-tag type="info" effect="dark">{{ $title +
          $version }}</el-tag></div>
      </div>
    </Transition>
    <photoswiper @my_ontouchend="pswp_click"></photoswiper>
    <el-header class="header" ref="header" height="90">
      <div class="header2" v-if="fullmode">
        <div style="margin-left:10px;opacity:0.6;">{{ $title + $version }}</div>
        <div class="headtitle">{{ task_info.taskname }}</div>
        <el-button v-if="task_info.status != 'yes'" circle class="el-icon-close"
          style="margin-right:3px;position: relative;z-index: 12;transform: scale(0.6);font-size: 22px;" type="primary"
          size="mini" @click="beforelogout"></el-button>
      </div>
      <!-- ========自定义mytabs======== -->
      <div style="position:relative;">
        <div class="mytabs_wrap" ref="mytabs">
          <div id="mytab0" :class="mytabs_btn_show ? 'mytabs_item mytabs_leftfix' : 'mytabs_item'"
            @click="menu_select({ name: '全部' }, 0)">
            <input type="radio" id="mytab_item0" class="mytabs_item_radio" name="tab" checked="checked">
            <label class="mytabs_item_label" for="mytab_item0">全部 ({{ serverfiles.length }})</label>
          </div>
          <div id="mytab1" class="mytabs_item" @click="menu_select({ name: '推荐' }, 1)">
            <input type="radio" id="mytab_item1" class="mytabs_item_radio" name="tab">
            <label class="mytabs_item_label" for="mytab_item1">推荐 ({{ calc_tagcount('推荐') }})</label>
          </div>
          <div id="mytab2" class="mytabs_item" @click="menu_select({ name: '已标记' }, 2)">
            <input type="radio" id="mytab_item2" class="mytabs_item_radio" name="tab">
            <label class="mytabs_item_label" for="mytab_item2">已选 ({{ calc_tagcount('已标记') }})</label>
          </div>
          <div :id="'mytab' + (tagindex + 3)" class="mytabs_item" v-for="(tagitem, tagindex) in task_info.tags"
            :index="tagitem" :key="tagindex" @click="menu_select({ name: tagitem }, tagindex + 3)">
            <input type="radio" :id="'mytab_item' + (tagindex + 3)" class="mytabs_item_radio" name="tab">
            <label class="mytabs_item_label" :for="'mytab_item' + (tagindex + 3)">{{ tagitem }} ({{
              calc_tagcount(tagitem) }})</label>
          </div>
          <div :id="'mytab' + (task_info.tags.length + 3)"
            :class="mytabs_btn_show ? 'mytabs_item mytabs_rightfix' : 'mytabs_item'"
            @click="menu_select({ name: '未标记' }, task_info.tags.length + 3)" ref="mytabs_last">
            <input type="radio" :id="'mytab_item' + (task_info.tags.length + 3)" class="mytabs_item_radio" name="tab">
            <label class="mytabs_item_label" :for="'mytab_item' + (task_info.tags.length + 3)">未选 ({{
              serverfiles.length - calc_tagcount('已标记') }})</label>
          </div>
        </div>
        <Transition>
          <div v-if="mytabs_btn_show" class="mytabs_leftarrow el-icon-arrow-left" @click="mytabs_arrow_click('left')">
          </div>
        </Transition>
        <Transition>
          <div v-if="mytabs_btn_show" class="mytabs_rightarrow el-icon-arrow-right" @click="mytabs_arrow_click('right')">
          </div>
        </Transition>
      </div>
      <!-- ========自定义mytabs======== -->

      <!-- <div class="tabs_wrap">
              <el-tabs v-model="default_menu" @tab-click="menu_select" stretch tab-position="top" ref="tabs">
                  <el-tab-pane name="全部">
                      <span slot="label">全部 ({{ serverfiles.length }})</span>
                  </el-tab-pane>
                  <el-tab-pane name="推荐">
                      <span slot="label">推荐 ({{ calc_tagcount('推荐') }})</span>
                  </el-tab-pane>
                  <el-tab-pane name="已标记">
                      <span slot="label">已选 ({{ calc_tagcount('已标记') }})</span>
                  </el-tab-pane>
                  <el-tab-pane v-for="(tagitem, tagindex) in task_info.tags" :index="tagitem" :key="tagindex"
                      :name="tagitem">
                      <span slot="label">{{ tagitem }} ({{ calc_tagcount(tagitem) }})</span>
                  </el-tab-pane>
                  <el-tab-pane name="未标记">
                      <span slot="label">未选 ({{ serverfiles.length - calc_tagcount('已标记') }})</span>
                  </el-tab-pane>
              </el-tabs>
          </div> -->
    </el-header>
    <el-main :class="isphone ? 'main' : 'main app'">
      <div class="explorer_wrap" ref="explorer">
        <div v-for="(item, index) in explorer_files" :key="item.filename"
          :class="item.selected ? 'item_wrap item_wrap_selected' : 'item_wrap'" :tabindex="index"
          @click.stop="initPhotoSwipe(index)">
          <span class="index_text">{{ index + 1 }}</span>
          <el-image class="item_img" :src="item.signatureUrl" fit="contain" :draggable="false">
            <!-- <img :src="item.signatureUrl" slot="placeholder" class="item_img"
                                          style="object-fit: contain;" /> -->
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"> 加载中...</i>
            </div>
          </el-image>
          <span class="filename">{{ item.filename }}</span>
          <div class="item_tags">
            <el-tag v-if="checktag(item.filename, '推荐')" class="item_tag" effect="dark" type="danger">推荐</el-tag>
            <template v-for="tag in task_info.tags">
              <el-tag class="item_tag" effect="dark" :key="tag" type="normal" v-if="checktag(item.filename, tag)">{{ tag
              }}</el-tag>
            </template>

          </div>
        </div>
      </div>
      <div style="height:20px;margin-top:120px;"></div>
    </el-main>
    <el-footer class="footer" ref="footer" v-if="fullmode">
      <div>
        <span>已选 {{ calc_tagcount('已标记') }}/{{ task_info.ruce_num }} 张</span>
        <span v-if="calc_tagcount('已标记') > task_info.ruce_num && task_info.over_price_show == 'yes'"
          style="margin-left:10px;">加片金额 ￥{{
            (calc_tagcount('已标记') - task_info.ruce_num) * task_info.over_price }}元</span>
        <span v-else></span>
      </div>
      <div>
        <el-button v-if="task_info.status == 'yes'" type="danger" :size="isphone ? 'mini' : 'medium'"
          @click="logout">退出</el-button>
        <el-button v-else type="danger" icon="el-icon-lock" :size="isphone ? 'mini' : 'medium'"
          @click="beforeLock">保存</el-button>
      </div>
    </el-footer>
    <el-dialog class="loginwrap" :visible.sync="showlogin" :show-close="false" :before-close="handleClose">
      <div slot="title"
        style="color:rgb(235, 235, 235);line-height: 24px;font-size:18px;width:100%;display:flex;justify-content: space-between;align-items: center;">
        <div style="display:flex;align-items:center;">
          <el-image src="https://jcyunxp-v2024-local.oss-cn-shenzhen.aliyuncs.com/logo3_256.png"
            style="width:28px;height:28px;margin-right:10px;"></el-image>
          <span style="margin-right:4px;">{{ $title }}</span>
        </div>
        <el-tag type="info" size="mini">{{ $version }}</el-tag>
      </div>
      <el-form :model="loginform" :rules="loginrules" ref="loginform" label-width="0" :disabled="disform"
        @submit.native.prevent>
        <el-form-item prop="password" label="">
          <el-input type="text" placeholder="请输入选片密码" v-model="loginform.password" autocomplete="off"
            @keyup.enter.native="before_login()" suffix-icon="el-icon-lock" clearable></el-input>
        </el-form-item>
        <div class="login-btn">
          <el-button :disabled="load_ali_js" id="button" type="primary" class="login-btn"
            @click="before_login()">开始选片</el-button>
          <button id="hiddenbutton" style="display:none;opacity:0;width:0;height:0;" class="hiddenbutton"></button>
          <!-- <button v-if="$captcha == 'aliyun'" id="button">开始选片</button> -->
        </div>
        <div align="center" class="beian">
          <div style="margin-top:14px;font-size:12px;color:#909399">新平捷晨科技</div>
          <el-link :underline="false" type="info" href="https://beian.miit.gov.cn/" target="_blank"
            onclick="return false;" style="font-size:12px;margin-top:10px;">{{ $beian }}
          </el-link>
          <div style="margin-top:14px;font-size:12px;color:#909399">本页面已适配移动端和PC端</div>
          <el-link :underline="false" type="info" href="https://yxp.xpjckj.cn/"
            style="font-size:12px;margin-top:10px;">返回官网</el-link>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog v-if="$captcha == 'self'" title="验证" :visible.sync="centerDialogVisible" width="300px" center
      style="user-select: none;">
      <drag-verify-img-chip ref="dragVerify" :imgsrc="imgsrc" :isPassing.sync="isPassing" :showRefresh="true"
        :barWidth="40" handlerIcon="el-icon-d-arrow-right" successIcon="el-icon-circle-check"
        refreshIcon="el-icon-refresh" @refresh="handleRefresh" @passcallback="handlePass" successText="验证成功"
        text="请按住滑块拖动" successTip="验证成功" background="#505050" textColor="#9e9e9e" handlerBg="#606060"
        progressBarBg="#3a3a3a" completedBg="#3a3a3a">
      </drag-verify-img-chip>
    </el-dialog>
    <div v-if="$captcha == 'aliyun'" id="captcha-element"></div>

  </el-container>
</template>


<script>
(function () {
  if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
    handleFontSize();
  } else {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", handleFontSize);
      document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
    }
  }

  function handleFontSize() {
    // 设置网页字体为默认大小
    WeixinJSBridge.invoke('setFontSizeCallback', {
      'fontSize': 0
    });
    // 重写设置网页字体大小的事件
    WeixinJSBridge.on('menu:setfont', function () {
      WeixinJSBridge.invoke('setFontSizeCallback', {
        'fontSize': 0
      });
    });
  }
})();
import webindex from '@/components/webindex.vue';
import photoswiper from '@/components/photoswiper.vue';
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'
import PhotoSwipe from 'photoswipe/dist/photoswipe'
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default'
import api from "@/utils/api.js"
import mk from "@/utils/marks.js"
import oss from "@/utils/aliyun_oss.js"
import cache from "@/utils/cache.js"
import dragVerifyImgChip from "vue-drag-verify-img-chip";
const t1 = "https://jcyunxp-v2024-local.oss-cn-shenzhen.aliyuncs.com/login/t1.png";
const t2 = "https://jcyunxp-v2024-local.oss-cn-shenzhen.aliyuncs.com/login/t2.png";
const t3 = "https://jcyunxp-v2024-local.oss-cn-shenzhen.aliyuncs.com/login/t3.png";
const t4 = "https://jcyunxp-v2024-local.oss-cn-shenzhen.aliyuncs.com/login/t4.png";

var loading = Object


function loadJS(url) {
  return new Promise((resolve) => {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    // IE
    if (script.readyState) {
      script.onreadystatechange = () => {
        if (script.readyState == 'loaded'
          || script.readyState == 'complete') {
          script.onreadystatechange = null;
          resolve();
        }
      };
    } else {
      // 其他浏览器
      script.onload = function () {
        resolve();
      };
    }
    document.getElementsByTagName('head')[0].appendChild(script);
  })
}

export default {
  name: 'yxp_explorer',
  components: {
    photoswiper,
    dragVerifyImgChip,
    webindex
  },
  data() {

    return {
      phone: oss.url_safe_base64_decode(this.getQueryParam()),
      id: cache.getcache('id'),
      shopname: '...',
      task_info: { tags: [], status: 'yes', ruce_num: 0 },
      mytags: {},
      serverfiles: [],
      preview_files: [],
      preview_index: 0,
      explorer_files: [],
      default_menu: '全部',
      default_menu_index: 0,
      show_mark_btn: false,
      height: 100,
      width: 100,
      orientation: 'landscape',
      isphone: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      mytabs_btn_show: false,
      loginform: {
        password: '',
        phone: '',
      },
      disform: false,
      showlogin: false,
      loginrules: {
        password: [
          { required: true, message: '请输入选片密码', trigger: 'blur' }
        ],
      },
      centerDialogVisible: false,
      isPassing: false,
      imgsrc: t3,
      location: '',
      fullmode: true,
      load_ali_js: true,
      web_index: false,
      task_timer: null,
      is_preview: false
    };
  },
  watch: {

  },
  computed: {

  },
  created() {
    // window.history.forward(1);
    document.oncontextmenu = function (e) {
      e.preventDefault()
    }
    window.addEventListener('resize', this.calc_resize)
    window.addEventListener('orientationchange', this.calc_resize)
  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {
    document.onkeydown = null;
    document.onkeyup = null;
  },
  async mounted() {
    //this.location = Location.href
    try {
      this.loginform.phone = oss.url_safe_base64_decode(this.getQueryParam())
      if (oss.url_safe_base64_decode(this.getQueryParam()) == 'demo') {
        this.loginform.password = '123456'
      }
    } catch (e) {
      this.alert('无效的选片链接', 'error')
      this.showlogin = true
      this.disform = true
    }
    if (!this.loginform.phone) {
      //this.alert('无效的选片链接', 'error')
      this.web_index = true
      this.showlogin = true
      this.disform = true
      document.onkeydown = null;
      document.onkeyup = null;
    } else {
      this.keyDown()
      this.get_user_info()
    }

    if (this.$captcha != 'aliyun') {
      this.load_ali_js = false
    }
  },
  methods: {
    // 监听键盘 
    keyDown() {
      console.log('==================start keydown=======================')
      // 键盘按下事件
      document.onkeydown = (e) => {
        // 取消默认事件
        //e.preventDefault();
        //事件对象兼容
        //let e1 = e || event || window.event || arguments.callee.caller.arguments[0]
        //键盘按键判断:左箭头-37;上箭头-38；右箭头-39;下箭头-40  回车：13   ctrl：17   shift：16
        //console.log('keydown',e1.keyCode)
      }
      // 键盘抬起事件
      document.onkeyup = (e) => {
        // 取消默认事件
        e.preventDefault();
        //事件对象兼容
        let e1 = e || event || window.event || arguments.callee.caller.arguments[0]
        if (e1.keyCode == 32 || e1.keyCode == 45 || e1.keyCode == 96) {
          if (this.is_preview && !this.isphone) {
            let item = this.task_info.tags[0]
            let v = this.checktag(this.preview_files[this.preview_index].title, item)
            this.swiper_markbtn_click(!v, item)
            //console.log(item,v)
          }
        }
        //console.log('keyup',e1.keyCode)
      }
    },
    close_swipe() {
      try {
        this.gallery.close()
      } catch (e) {

      }
    },
    async init_aliyun_captcha() {
      let that = this
      await loadJS('https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js')
      try {
        initAliyunCaptcha({
          SceneId: 'a2nbjyd5', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
          prefix: '1d878y', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
          mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
          element: '#captcha-element', //页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
          button: '#hiddenbutton', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
          captchaVerifyCallback: captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
          onBizResultCallback: onBizResultCallback, // 业务请求结果回调函数，无需修改
          getInstance: getInstance, // 绑定验证码实例函数，无需修改
          slideStyle: {
            width: 360,
            height: 40,
          }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
          language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
        });
      } catch (e) {
        console.log(e)
      }
      let captcha;
      function getInstance(instance) {
        that.load_ali_js = false
        captcha = instance;
        // let fun=document.getElementById('button').onclick
        // document.getElementById('button').onclick=function(){
        //   alert('123')
        //   fun
        // }
        console.log('ok=============================================')
      }
      async function captchaVerifyCallback(captchaVerifyParam) {
        let data = {
          captchaVerifyParam: captchaVerifyParam,
        }
        const result = await api.captcha(data)
        console.log('captchaVerifyParam', result)
        const verifyResult = {
          captchaResult: result,
          bizResult: result
        };
        return verifyResult;
      }

      function onBizResultCallback(bizResult) {
        if (bizResult === true) {
          that.submitLoginForm()
        }
      }
    },
    getQueryParam(name = 'p') {
      // const path = window.location.pathname;
      // const parts = path.split('/');
      // const ps = parts[parts.length - 2];
      // const p = parts[parts.length - 1];
      // if (ps == 'p') {
      //   return p;
      // } else {
      //   return ''
      // }

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      return urlParams.get(name);
    },
    beforelogout() {
      this.$confirm('即将退出, 是否继续?', this.$title + this.$version, {
        confirmButtonText: '继续',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.logout()
      }).catch(() => {

      });
    },
    logout() {
      cache.setcache('id', -1, 0)
      this.id = -1
      this.disform = false
      this.showlogin = true
      this.task_info = { tags: [], status: 'yes', ruce_num: 0 }
      this.mytags = {}
      this.serverfiles = []
      this.preview_files = []
      this.preview_index = 0
      this.explorer_files = []
      this.loginform.password = ''
      this.default_menu = '全部'
      try {
        if (this.gallery) {
          this.gallery.close()
        }
        if (oss.url_safe_base64_decode(this.getQueryParam()) == 'demo') {
          this.loginform.password = '123456'
        }
        if (this.task_timer) {
          clearInterval(this.task_timer)
        }
      } catch (e) { console.log(e) }
    },
    continue_login(type = '') {
      cache.updatecache('id', 1200)
      console.log('continue_login', type)
    },
    beforeLock() {
      this.$confirm('即将锁定选片结果, 是否继续?', this.$title + this.$version, {
        confirmButtonText: '继续锁定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doLock()
      }).catch(() => {

      });
    },
    async doLock() {
      if (this.task_info.demo == 'yes') {
        this.msg('此为示例选片不能锁定', 'info')
        return;
      }
      if (this.calc_tagcount('已标记') <= 0) {
        this.msg('还没有标记任何照片哦', 'info')
        return;
      }
      let data = {
        id: cache.getcache('id'),
        phone: this.phone,
        status: 'yes'
      }
      this.showloading()
      let ret = await api.set_xp_status(data)
      this.hideloading()
      if (ret.code != 0) {
        this.alert('锁定失败: ' + ret.msg, 'error')
        this.logout()
      } else {
        this.get_task_info()
      }
    },
    menu_select(v, index) {
      this.continue_login()
      v = v.name
      console.log(v)
      //if(v==this.default_menu) return
      if (v == '全部') {
        this.explorer_files = Object.assign([], this.serverfiles)
      } else if (v == '未标记') {
        this.explorer_files = Object.assign([], this.serverfiles)
        this.explorer_files = mk.getfiles_by_tagname_not_mark(v, this.task_info.marks, this.explorer_files)
      } else {
        this.explorer_files = Object.assign([], this.serverfiles)
        this.explorer_files = mk.getfiles_by_tagname(v, this.task_info.marks, this.explorer_files)
      }
      // console.log('this.explorer_files====', this.explorer_files)
      // this.explorer_files.sort(function (a, b) {
      //     return a.size < b.size;
      // })
      let preview_files = []
      if (this.explorer_files.length != 0) {
        preview_files = this.explorer_files.map(file => {
          return {
            src: file.signatureUrl_Big,
            msrc: file.signatureUrl,
            title: file.filename,
            w: file.width,
            h: file.height
          };
        })
      }

      this.preview_files = preview_files
      this.default_menu = v
      this.default_menu_index = index

      console.log('index:', index)
      try {
        let len = this.task_info.tags.length + 4
        let width = window.innerWidth
        let e = document.getElementById('mytab' + index)
        let r = e.getBoundingClientRect().right
        let l = e.getBoundingClientRect().left
        let c = (e.getBoundingClientRect().width / 2) + l

        if (c > width / 2) {
          if (index < len - 1)
            e = document.getElementById('mytab' + (index + 1))
        } else {
          if (index > 0)
            e = document.getElementById('mytab' + (index - 1))
        }
        console.log('e:', e)
        e.scrollIntoView({
          behavior: "smooth",
          block: "end",
        })
        console.log('r>width', r, width)
      } catch (e) {
        console.log('error', e)
      }
    },
    mytabs_arrow_click(v) {
      let width = window.innerWidth
      if (v == 'right') {
        for (let i = 0; i < this.task_info.tags.length + 4; i++) {
          let e = document.getElementById('mytab' + i)
          let r = e.getBoundingClientRect().right
          if (r > width) {
            e.scrollIntoView({
              behavior: "smooth",
              block: "end",
            })
            break;
          }
          console.log(r, width)
        }
      } else {
        let len = this.task_info.tags.length + 4
        for (let i = 0; i < len; i++) {
          let e = document.getElementById('mytab' + (len - i - 1))
          let l = e.getBoundingClientRect().left
          if (l < 0) {
            e.scrollIntoView({
              behavior: "smooth",
              block: "end",
            })
            break;
          }
          console.log(l, width)
        }
      }

      // let obj = this.$refs.mytabs_last
      // obj.scrollIntoView()
    },
    calc_resize() {
      //let objtabs = this.$refs.mytabs_last
      if (this.task_info.tags.length == 0) {
        return;
      }
      let n = 'mytab' + (this.task_info.tags.length + 3)
      let objtabs = document.getElementById(n)
      try {
        let tabswidth = Math.round(objtabs.getBoundingClientRect().right)
        let width = window.innerWidth
        //console.log('calc_resize',tabswidth,width)
        if (width < tabswidth) {
          if (!this.mytabs_btn_show)
            this.mytabs_btn_show = true
          //console.log('show btn')
        } else {
          if (this.mytabs_btn_show)
            this.mytabs_btn_show = false
          //console.log('hide btn')
        }
        let h = parseInt(window.innerHeight)
        let w = parseInt(window.innerWidth)
        if (w > h) {
          this.orientation = 'landscape'
        } else {
          this.orientation = 'portrait'
        }
        console.log('w h========', w, h, this.isphone)
        if (w > h && this.isphone && h < 500) {
          //this.alert('竖屏模式才能显示完整功能,建议旋转至竖屏模式并锁定屏幕旋转.')
          this.fullmode = false
        } else {
          this.fullmode = true
        }
      } catch (e) { console.log(e) }

    },
    // getHeight() {
    //     return;
    //     let obj=this.$refs.explorer
    //     let width=0
    //     if(obj){
    //         width=obj.offsetWidth
    //     }
    //     let h = parseInt(window.innerHeight)
    //     let w = parseInt(window.innerWidth)
    //     if (w > h) {
    //         this.orientation = 'landscape'
    //     } else {
    //         this.orientation = 'portrait'
    //     }
    //     console.log('width', width)
    // },
    showloading() {
      loading = this.$loading({
        lock: true,
        text: this.loading_tip,
        // spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    hideloading() {
      setTimeout(() => {
        loading.close()
      }, 300);
    },
    alert(text, type = 'info') {
      this.$alert(text, this.$title + this.$version, { type: type });
    },
    msg(message, type = 'info') {//success/warning/info/error
      this.$message({
        message: message,
        type: type
      });
    },
    async get_user_info() {
      this.showloading()
      let data = {
        phone: oss.url_safe_base64_encode(this.phone)
      }
      let result = await api.get_user_info(data)
      this.hideloading()
      if (result.code == 0) {
        this.disform = false
        this.shopname = result.info.shopname
        document.title = result.info.shopname
        if (oss.url_safe_base64_decode(this.getQueryParam()) == 'demo') {
          document.title = '选片示例'
        }
        if (this.loginform.phone && cache.getcache('id')) {
          this.get_task_info()
        } else {
          this.disform = false
          this.showlogin = true
          if (this.$captcha == 'aliyun') {
            this.init_aliyun_captcha()
          }
        }
      } else {
        this.disform = true
        this.showlogin = true
        this.alert(result.msg, 'error')
      }
    },
    async get_task_marks() {
      let data = {
        phone: oss.url_safe_base64_encode(this.phone),
        id: cache.getcache('id')
      }
      let result = await api.get_task_marks(data)
      if (result.code == 0) {
        this.continue_login()
        if (!result.task_info.marks) {
          //this.task_info.marks = []
        } else {
          this.task_info.marks = result.task_info.marks
        }
        this.showlogin = false
        this.disform = false
      } else {
        this.showlogin = true
        this.disform = true
        this.alert(result.msg, 'error')
        cache.setcache('id', -1, 0)
      }
    },
    async get_task_info() {
      this.showloading()
      let data = {
        phone: oss.url_safe_base64_encode(this.phone),
        id: cache.getcache('id')
      }
      let result = await api.get_task_info(data)

      if (result.code == 0) {
        this.continue_login()
        this.task_info = result.task_info
        console.log('result.task_info', result.task_info)
        this.task_info.watermark_style = oss.get_watermark_style(result.task_info.watermarkjson)
        if (result.task_info.watermark == '-3') {
          this.task_info.watermark_style = oss.get_watermark_style_default3(this.shopname)
        }
        if (result.task_info.watermark == '-2') {
          this.task_info.watermark_style = oss.get_watermark_style_default2(this.shopname)
        }
        if (!this.task_info.marks) {
          this.task_info.marks = []
        }
        if (this.task_info.status == 'yes') {
          this.alert('当前已锁定选片, 只可浏览, 不可标记.')
        } else {
          this.afterlogin()
        }
        setTimeout(() => {
          this.calc_resize()
          this.get_serverfiles()
        }, 500);
        console.log('this.task_info.marks', this.task_info.marks)
        this.showlogin = false
        this.disform = false
        if (!this.task_timer) {
          this.task_timer = setInterval(() => {
            this.get_task_marks()
          }, 5000);
        }
      } else {
        this.showlogin = true
        this.disform = true
        this.alert(result.msg, 'error')
        cache.setcache('id', -1, 0)
      }
      this.hideloading()
    },
    rndsort() {
      return Math.random() > .5 ? -1 : 1;
    },
    async get_serverfiles(force = false) {
      //this.showloading()
      this.serverfiles = []
      this.preview_files = []
      let pp = this.phone == 'demo' ? this.phone : oss.url_safe_base64_encode(this.phone)
      let server_files = await oss.get_list("upload/" + pp + "/" + cache.getcache('id') + "/", this.task_info.watermark_style, force)
      if (server_files.length == 0) {
        this.$alert('获取照片列表失败', this.$title + this.$version, {
          confirmButtonText: '重试',
          callback: () => {
            this.get_serverfiles(true)
          }
        });
        return
      }
      if (this.task_info.rnd == 'yes') {
        server_files = server_files.sort(this.rndsort)
      }
      let preview_files = server_files.map(file => {
        return {
          src: file.signatureUrl_Big,
          msrc: file.signatureUrl,
          title: file.filename,
          w: file.width,
          h: file.height
        };
      })
      this.preview_files = preview_files
      this.serverfiles = server_files
      this.explorer_files = Object.assign([], server_files)
      this.menu_select({ name: this.default_menu }, this.default_menu_index)
      console.log('this.serverfiles', this.serverfiles)
      //this.hideloading()
    },
    swiper_markbtn_click(v, tagname) {
      console.log('swiper_markbtn_click', v, tagname, this.preview_files)
      let filename = this.preview_files[this.preview_index].title
      if (v) {
        mk.add(this.task_info.marks, tagname, filename)
        if (this.task_info.maintag == 'yes' && tagname != '推荐' && tagname != this.task_info.tags[0]) {//主标记也同时选中
          mk.add(this.task_info.marks, this.task_info.tags[0], filename)
        }
      } else {
        mk.remove(this.task_info.marks, tagname, filename)
      }
      this.save_marks(false)
      console.log('swiper_markbtn_click', v)
    },
    checktag(filename, tagname) {
      return mk.exist(this.task_info.marks, tagname, filename)
    },
    calc_tagcount(tagname) {
      return mk.calc_tagcount(this.task_info.marks, tagname)
    },
    calc_tag_all_count() {//删除文件后，重新计算
      console.log('calc_tag_all_count before', this.task_info.marks)
      mk.calc_tagcount(this.task_info.marks, '精修')
      console.log('calc_tag_all_count after', this.task_info.marks)
    },
    async save_marks(showmsg = true) {
      let marks = JSON.stringify(this.task_info.marks)
      let data = {
        marks: marks,
        phone: this.phone,
        id: cache.getcache('id')
      }
      this.showloading()
      let result = await api.save_marks(data)
      this.hideloading()
      if (result.code == 0) {
        this.continue_login()
        //this.get_task_info()
        if (showmsg)
          this.msg(result.msg, 'success')
        console.log('save_marks', marks)
        this.get_task_marks()
        //this.menu_select({ name: this.default_menu }, this.default_menu_index)
      } else {
        this.logout()
        if (showmsg)
          this.msg(result.msg, 'error')
        console.log('save_marks:error', result.msg)
      }

    },
    initPhotoSwipe(index) {
      //console.log(this.localfiles)
      //return;
      const options = {
        timeToIdle: 0,
        fullscreenEl: false,
        shareEl: false,
        arrowEl: true,
        preloaderEl: true,
        loop: true,
        modal: true,
        preload: [3, 6],
        tapToClose: false,
        closeOnVerticalDrag: false,
        closeOnScroll: false,
        bgOpacity: 0.85,
        showHideOpacity: true,
        // hideAnimationDuration: 0,
        // showAnimationDuration: 0,
        index: index,
        history: false,
        errorMsg: '<div class="pswp__error-msg">图片已过期,请刷新页面.</div>',
      }
      let files = []
      files = this.preview_files
      let pswpElement = document.querySelectorAll('.pswp')[0];//this.$refs.pswpWrap
      this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUIDefault, files, options);
      this.gallery.init();
      this.get_task_marks()
      Location.href = this.location
      //this.show_mark_btn = true
      this.preview_index = index
      this.is_preview = true
      this.gallery.listen('afterChange', () => {
        this.preview_index = this.gallery.getCurrentIndex();
        //this.$forceUpdate()
        this.continue_login()
        console.log('afterChange preview_index', this.preview_index, this.preview_files[this.preview_index].title);
        //this.$emit('afterChange')
        this.pswp_click()

      });
      this.gallery.listen('close', () => {
        this.show_mark_btn = false
        this.continue_login()
        this.menu_select({ name: this.default_menu }, this.default_menu_index)
        this.get_task_marks()
        this.is_preview = false
      });
      this.continue_login()
      this.pswp_click()
      if (!cache.getcache('showtip') && window.innerWidth < 500) {
        setTimeout(() => {
          this.show_control_desc()
        }, 2000);
        cache.setcache('showtip', 'yes', 1200)
      }
    },
    show_control_desc() {
      this.$alert('【点击图片】显示/隐藏 工具栏<br />【双击图片】放大/缩小 图片<br />【双指打开】放大图片<br />【双指合起】缩小图片/关闭预览<br />【左右滑动】切换上一张/下一张照片<br />【标记图片】点击按钮变为蓝色<br />【取消标记】点击按钮变为灰色<br /><br />预览图将于60分钟后过期<br />届时刷新页面即可', this.$title + this.$version + ' 操作提示', {
        dangerouslyUseHTMLString: true, type: 'info'
      });
    },
    pswp_click() {
      this.continue_login()
      //console.log('zoom',this.gallery.getZoomLevel(),this.gallery.isMainScrollAnimating())
      setTimeout(() => {
        let obj = document.getElementById('pswpui')
        let classname = obj.getAttribute("class")
        //pswp__ui--hidden
        if (classname.indexOf('pswp__ui--hidden') == -1) {
          this.show_mark_btn = true
        } else {
          this.show_mark_btn = false
        }
        console.log('pswp_click', this.show_mark_btn)
      }, 333);
    },
    handleClose() {
      return false;
    },
    sortList(list, needSort) {
      const _list = list.map(li => li) // ['A', 'B', 'C']
      return needSort.sort((a, b) => {
        return _list.indexOf(a.name) < _list.indexOf(b.name) ? -1 : 1;
      });
    },
    //登录
    handleRefresh() {
      var oldt = this.lastt
      var t = 1
      while (t == oldt) {
        t = this.random(1, 4)
      }

      this.lastt = t
      switch (t) {
        case 1:
          this.imgsrc = t1;
          break;
        case 2:
          this.imgsrc = t2;
          break;
        case 3:
          this.imgsrc = t3;
          break;
        case 4:
          this.imgsrc = t4;
          break;
      }
    },
    before_login() {
      this.$refs.loginform.validate(valid => {
        if (valid) {
          if (this.$captcha == 'self') {
            this.centerDialogVisible = true;
            this.handleRefresh();
          } else {
            document.getElementById('hiddenbutton').onclick()
          }
        } else {
          //this.$message.error('请输入账号和密码');
          return false;
        }
      });
    },
    async submitLoginForm() {
      this.showloading()
      let data = {
        phone: oss.url_safe_base64_encode(this.loginform.phone),
        password: oss.url_safe_base64_encode(this.loginform.password)
      }
      cache.setcache('id', -1, 0)
      let result = await api.login_xp(data)
      this.hideloading()
      if (result.code == 0) {
        cache.setcache('id', result.id, 1200)
        this.get_task_info()
      } else {
        this.alert(result.msg)
      }
    },
    afterlogin() {
      if (this.task_info.status == 'no') {
        let data = {
          id: cache.getcache('id'),
          phone: this.phone,
          status: 'run'
        }
        api.set_xp_status(data)
      }
    },
    handleReset() {
      this.isPassing = false;
      this.$refs.dragVerify.reset();
    },
    handlePass() {
      this.submitLoginForm()
      this.centerDialogVisible = false
    },
    random(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    },
  }
};
</script>

<style>
body {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  -webkit-overflow-scrolling: touch;
  -webkit-user-drag: none;
  overflow: hidden;
}

.header {
  background-color: #303030;
}

.footer {
  background-color: #303030;
}

.beian {
  opacity: 0.5;
  margin-top: 25px;
}

.el-dialog {
  margin-top: 5vh !important;
  /* min-width: 300px; */
}

.el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-message-box {
  max-width: 90vw !important;
}

.drag_verify .dv_handler i {
  color: white !important;
}

.login-btn {
  text-align: center;
  width: 100%;
}

@media screen and (max-width: 500px) {
  /*手机最大宽度500*/

  /* 在屏幕宽度小于或等于600px时应用的样式 竖屏 */
  .loginwrap>.el-dialog {
    width: 90%;
  }

  .item_wrap {
    width: calc(32% - 8px) !important;
    height: 34vw !important;
  }

  .item_img {
    width: 27vw !important;
    height: 28vw !important;
    position: relative;
  }

  .image-slot {
    width: 27vw !important;
    height: 28vw !important;
  }

  .item_tags {
    padding: 1px 1px !important;
    opacity: 0.8 !important;
    line-height: 12px !important;
  }

  .item_tag.el-tag--small {
    margin: 1px !important;
    font-size: 10px !important;
    height: auto !important;
    padding: 1px 2px !important;
    line-height: 10px !important;
    border-radius: 0 !important;
  }

  .filename {
    font-size: 9px !important;
    line-height: 16px !important;
    width: 17vw !important;
  }

  .index_text {
    font-size: 12px !important;
    opacity: 0.5 !important;
  }

  .pswp__caption {
    bottom: auto !important;
    top: 0 !important;
    font-size: 10px !important;
  }

  .pswp__top-bar {
    display: none !important;
  }

  .pswp__img {
    -moz-user-select: none !important;
    -webkit-user-select: none !important;
    -ms-user-select: none !important;
    -webkit-touch-callout: none !important;
    user-select: none !important;
    pointer-events: none;
    top: -5px;
  }

  /* .el-tabs__nav-scroll {
  overflow-x: overlay !important;

  &::-webkit-scrollbar {
    display: none !important;
  }
} */
  .footer {
    height: 50px !important;
    font-size: 12px !important;
  }
}

@media screen and (max-width:900px) and (min-width:501px) {
  .item_tag.el-tag--small {
    margin: 1px !important;
    font-size: 10px !important;
    height: auto !important;
    padding: 1px 2px !important;
    line-height: 10px !important;
    border-radius: 0 !important;
  }
}

@media screen and (max-width:1199px) and (min-width:501px) {
  /*平板 小于1199 大于501px*/

  /* 在屏幕宽度小于或等于940px时应用的样式 横屏*/
  .loginwrap>.el-dialog {
    width: 60%;
    max-width: 350px !important;
  }

  .item_wrap {
    width: calc(16% - 7px) !important;
    height: 20vw !important;
  }

  .item_img {
    width: 14vw !important;
    height: 17vw !important;
    position: relative;
  }

  .image-slot {
    width: 14vw !important;
    height: 17vw !important;
  }

  .item_tags {
    padding: 1px 1px !important;
    opacity: 0.8 !important;
    line-height: 12px !important;
  }

  /* .item_tag.el-tag--small {
  margin: 1px !important;
  font-size: 10px !important;
  height: auto !important;
  padding:1px 2px !important;
  line-height: 10px !important;
  border-radius: 0 !important;
} */

  .filename {
    font-size: 10px !important;
    line-height: 16px !important;
    width: 10vw !important;
  }

  .index_text {
    font-size: 12px !important;
    opacity: 0.5 !important;
    left: 2px !important;
    bottom: 2px !important;
  }

  .pswp__caption {
    bottom: auto !important;
    top: 0 !important;
    font-size: 10px !important;
  }

  .pswp__top-bar {
    display: none !important;
  }

  .pswp__img {
    -moz-user-select: none !important;
    -webkit-user-select: none !important;
    -ms-user-select: none !important;
    -webkit-touch-callout: none !important;
    user-select: none !important;
    pointer-events: none;
  }
}

@media screen and (min-width: 1200px) {

  /*pc宽度大于1200px*/
  .loginwrap>.el-dialog {
    width: 60%;
    max-width: 350px !important;
  }

  .item_wrap {
    width: calc(11% - 9px) !important;
    height: 13vw !important;
  }

  .item_img {
    width: 9vw !important;
    height: 11vw !important;
    position: relative;
  }

  .image-slot {
    width: 9vw !important;
    height: 11vw !important;
  }

  .item_tags {
    padding: 0 1px !important;
    opacity: 0.8 !important;
    line-height: 12px !important;
  }

  /* .item_tag.el-tag--small {
  margin: 1px !important;
  font-size: 12px !important;
  height: auto !important;
  padding:1px 2px !important;
  line-height: 10px !important;
  border-radius: 0 !important;
} */

  .filename {
    font-size: 12px !important;
    line-height: 25px !important;
    width: 6vw !important;
  }

  .index_text {
    font-size: 12px !important;
    opacity: 0.5 !important;
    left: 2px !important;
    bottom: 2px !important;
  }
}

@media screen and (max-width: 1024px) {

  /* 平板设备横屏时应用的样式 */
  /* .ms-login {
  width: 35%;
  margin-top: -20vh;
  background-color: green;
} */

  /* .item_wrap {
  width: 15vw !important;
  height: 16vw !important;
}

.item_img {
  width: 15vw !important;
  height: 14vw !important;
  position: relative;
}

.item_tags {
  padding: 0 1px !important;
  opacity: 0.8 !important;
  line-height: 12px !important;
}

.item_tag.el-tag--small {
  margin: 1px !important;
  font-size: 10px !important;
  height: auto !important;
  padding:1px 2px !important;
  line-height: 10px !important;
  border-radius: 0 !important;
}

.filename {
  font-size: 10px !important;
  line-height: 16px !important;
  width: 10vw !important;
}

.index_text {
  font-size: 16px !important;
  opacity: 0.5 !important;
} */
}

@media screen and (max-width: 1200px) {

  /* 桌面设备应用的样式 */
  /* .el-tabs__nav-scroll {
  overflow-x: scroll !important;

  &::-webkit-scrollbar {
    display: none !important;
  }
} */
  /* .ms-login {
  width: 25%;
  max-width: 365px;
  margin-top: -20vh;
  background-color: rgb(0, 183, 255)
} */
}

@media screen and (min-width: 1200px) {

  /* 桌面设备应用的样式 */
  /* .ms-login {
  width: 25%;
  max-width: 365px;
  margin-top: -20vh;
  background-color: blue
} */

  /* .item_wrap {
  width: 13vw !important;
  height: 13vw !important;
}

.item_img {
  width: 13vw !important;
  height: 11vw !important;
  position: relative;
}

.item_tags {
  padding: 0 1px !important;
  opacity: 0.8 !important;
  line-height: 12px !important;
}

.item_tag.el-tag--small {
  margin: 1px !important;
  font-size: 10px !important;
  height: auto !important;
  padding:1px 2px !important;
  line-height: 10px !important;
  border-radius: 0 !important;
}

.filename {
  font-size: 12px !important;
  line-height: 16px !important;
  width: 8vw !important;
}

.index_text {
  font-size: 18px !important;
  opacity: 0.5 !important;
} */
}



.mytabs_wrap {
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  flex-wrap: nowrap;
  cursor: pointer;
  overflow-x: overlay;

  &::-webkit-scrollbar {
    display: none;
  }
}

.mytabs_item {
  min-width: 90px;
  white-space: nowrap;
  width: 100%;
}

.mytabs_item_radio {
  /* display: none; */
  position: absolute;
  opacity: 0;
}

.mytabs_item_radio:checked+.mytabs_item_label {
  background-color: rgb(85, 85, 85);
  color: rgb(255, 255, 255);
}

.mytabs_item_label {
  position: relative;
  display: inline-block;
  background-color: #303030;
  width: 100%;
  font-size: 14px;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  color: rgb(139, 139, 139);
}

.mytabs_leftarrow {
  position: absolute;
  display: flex !important;
  top: 0;
  left: 0;
  color: rgba(255, 255, 255, 0.2);
  width: 30px;
  height: 40px;
  background: linear-gradient(to right, #303030, #30303000);
  justify-content: flex-start;
  align-items: center;
  padding-left: 2px;
  cursor: pointer;
  opacity: 0.95;
}

.mytabs_rightarrow {
  position: absolute;
  display: flex !important;
  top: 0;
  right: 0;
  color: rgba(255, 255, 255, 0.2);
  width: 30px;
  height: 40px;
  background: linear-gradient(to right, #30303000, #303030);
  justify-content: flex-end;
  align-items: center;
  padding-right: 2px;
  cursor: pointer;
}

.mytabs_rightfix {
  padding-right: 20px;
}

.mytabs_leftfix {
  padding-left: 20px;
}

.swiper_marktag_btn {
  position: absolute;
  z-index: 2000;
  opacity: 0.9;
  top: 6px;
  left: 80px;
}

.swiper_marktag_btn_phone {
  position: fixed;
  z-index: 2000;
  opacity: 0.9;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.815);
  border-top: solid 0px rgba(255, 255, 255, 0.247);
  width: 100%;
  min-height: 160px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.swiper_marktags_phone_toptip {
  color: white;
  padding: 15px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  opacity: 1;
  position: relative;
  bottom: -4px;
}


.tagvalue {
  font-style: italic;
  opacity: 0.5;
  font-weight: normal;
}

.tagname {
  width: 10em;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-menu-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.el-menu-item.is-active {
  background-color: #555555 !important;
  font-weight: bold;
}


/* el-tabs */

::v-deep .el-tabs__header {
  margin: 0;
}

::v-deep .el-tabs__item {
  color: rgba(255, 255, 255, 0.4);
  padding: 0 20px !important;
  background-color: #303030;
}

::v-deep .el-tabs__item.is-active {
  color: rgba(255, 255, 255, 0.9);
  background-color: #555555;
}

::v-deep .el-tabs__nav-scroll {
  background-color: transparent !important;
  /* border-bottom: 4px #555555 solid; */
}

::v-deep .el-tabs__nav-wrap {
  margin-bottom: 0px !important;
}

::v-deep .el-tabs__nav-wrap.is-scrollable {
  background-color: rgb(63, 63, 63);
  /* display: none; */
}

::v-deep .el-tabs__active-bar {
  display: none;
}

::v-deep .el-tabs__nav-next {
  line-height: 40px;
  font-size: 16px;
  height: 40px;
  /* display: none; */
}

::v-deep .el-tabs__nav-prev {
  line-height: 40px;
  font-size: 16px;
  height: 40px;
}

::v-deep .el-tabs__nav-wrap::after {
  display: none;
}

/* ::v-deep .el-tabs__nav-scroll {
   overflow-x: scroll !important;
   &::-webkit-scrollbar {
       display: none !important;
   }
} */
.mycheck.el-checkbox-button.is-disabled .el-checkbox-button__inner {
  border: initial !important;
  border-right: 0;
  /* border-color: #f56c6c; */
  color: white !important;
}

.mycheck.el-checkbox-button.is-disabled.is-checked .el-checkbox-button__inner {
  background-color: #f56c6c !important;
  border: initial !important;
  border-right: 0;
  /* border-color: #f56c6c; */
  color: white !important;
}

.mycheck2.el-checkbox-button.is-disabled .el-checkbox-button__inner {
  border: initial !important;
  border-right: 0;
  /* border-color: #f56c6c; */
  color: white !important;
}

.mycheck2.el-checkbox-button.is-disabled.is-checked .el-checkbox-button__inner {
  background-color: rgb(62, 159, 254) !important;
  border: initial !important;
  border-right: 0;
  /* border-color: #f56c6c; */
  color: white !important;
}

.el-checkbox-button.is-checked .el-checkbox-button__inner {
  color: white !important;
}

.el-checkbox-button.is-focus .el-checkbox-button__inner {
  border-color: #40a0ff4b !important;
}


.swiper_marktags_phone {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  padding: 10px;
}

.marktag_phone.el-checkbox-button {
  display: flex;
  flex-grow: 1;
  white-space: nowrap;
  overflow: visible;
}

.marktag_phone.el-checkbox-button .el-checkbox-button__inner {
  border-radius: 4px !important;
  margin: 4px;
  white-space: nowrap;
  overflow: visible;
  flex-grow: 1;
  border: 0 !important;
}


.buttonarea {
  position: absolute;
  top: 70px;
  right: 0px;
  height: 40px;
  display: flex;
  align-items: center;
  padding-right: 4px;
}

.mask {
  background-color: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 50;
}

.mask_progress {
  position: relative;
  top: 50%;
  width: 30%;
  margin: 0 auto;
}

.mask_tip {
  width: 100%;
  position: relative;
  text-align: center;
  color: white;
  top: 49%;
}

.explorer_wrap {
  display: -webkit-flex;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-top: 5px;
  width: 100%;
  word-spacing: -5px;
}



.item_wrap {
  width: 280px;
  height: 270px;
  background-color: #666666;
  padding: 5px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-wrap: wrap;
  position: relative;
  overflow: hidden;
  margin: 0px;
  outline: 1px solid #525252;
}

.item_wrap:hover {
  background-color: rgb(71, 71, 71);
}

/* .item_wrap:active{
  background-color: #cce8ff;
} */
/* .item_wrap:focus {
  background-color: #cce8ff;
  outline: 1px solid #99d1ff !important;
} */

.item_wrap_selected,
.item_wrap_selected:hover {
  background-color: rgb(201, 201, 201);
  outline: 1px solid rgb(177, 177, 177) !important;
}

.item_img {
  height: 220px;
  width: 280px;
  position: relative;
}

.item_img_tip {
  position: absolute;
  bottom: 4px;
  font-size: 10px;
}

.item_tags {
  position: absolute;
  width: 100%;
  text-align: left;
  top: 0;
  left: 0;
  padding: 0;
  opacity: 0.9;
}

.item_tag {
  margin: 2px;
}

.filename {
  font-size: 14px;
  line-height: 30px;
  width: 280px;
  text-overflow: ellipsis;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  opacity: 0.2;
  color: white;
}

.index_text {
  font-weight: bold;
  font-size: 28px;
  color: white;
  opacity: 0.4;
  position: absolute;
  z-index: 20;
  background-color: transparent;
  left: 10px;
  bottom: 10px;
  text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.2);
}

.image-slot {
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 220px;
  width: 280px;
  background: #f5f7fa;
  color: #909399;
}

.wrapper {
  margin: 0;
}

.main {
  overflow-y: overlay;
  overflow-x: hidden;
  padding: 0;
  height: 100vh;
  width: 100%;
  background-color: #555555;
  /* overflow: overlay; */
}

.el-footer {
  padding: 0 20px !important;
}

.footer {
  height: 40px;
  position: fixed;
  color: #fff;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  z-index: 21;
}

.header2 {
  width: 100%;
  height: 40px !important;
  font-size: 12px;
  color: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  opacity: 0.8;
  /* -webkit-app-region: drag; */
}

.headtitle {
  width: 100%;
  height: 40px;
  text-align: center;
  position: absolute;
  line-height: 40px;
  z-index: 10;
}

.el-header {
  padding: 0 !important;
}

.v-enter-active {
  transition: opacity 0.333s ease;
}

.v-leave-active {
  transition: opacity 0.333s ease;
}

.v-enter {
  opacity: 0;
}

.v-enter-from {
  opacity: 0;
}

.v-leave-to {
  opacity: 0;
}

.el-dialog__wrapper {
  background-color: rgba(0, 0, 0, 0.856);
  opacity: 1;
}

.el-main {
  padding: 0 !important;
}

.toppest {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 65535;
  background-color: #303030;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  color: rgba(255, 255, 255, 0.781);
  font-size: 30px;
  font-weight: bold;
}

.hiddenbutton {
  display: none !important;
}
</style>
